export default __webpack_public_path__ + "static/media/home-startup-service-img-04.78f66c4f.jpg";